import FormInput from "components/beta/FormInput";
import { ReactElement } from "react";
import { FormProvider, useForm } from "react-hook-form";
import styled from "styled-components";
import {
  GenericCredentialDetails,
  formatDynamicAddCredAPIParams,
} from "../form-helpers";
import { useAppValues } from "lib/context/AppContext";

const StyledFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

interface Props {
  selectedCredKeyName: string;
}
export default function AddCredentialForm({
  selectedCredKeyName,
}: Props): ReactElement {
  const { getAppValues } = useAppValues();
  const { credentials } = getAppValues();
  if (!selectedCredKeyName) {
    throw new Error("No selectedCredKeyName in Add Credential Form");
  }
  const formattedCredName = selectedCredKeyName.toLowerCase();
  const credentialInfo = credentials[formattedCredName];
  const methods = useForm<Partial<GenericCredentialDetails>>();

  const handlePostCredential = async (
    data: Partial<GenericCredentialDetails>
  ) => {
    console.warn("data: ", data);
    if (!selectedCredKeyName) {
      return;
    }
    const formattedParams = formatDynamicAddCredAPIParams(data, credentialInfo);
    console.warn("formattedParams: ", formattedParams);
  };
  console.warn("credentialInfo: ", credentialInfo);

  return (
    <FormProvider {...methods}>
      <StyledFormContainer
        onSubmit={methods.handleSubmit(handlePostCredential)}
      >
        <FormInput placeholder="Enter" label="Label" type="text" name="test" />
      </StyledFormContainer>
    </FormProvider>
  );
}
